import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('saas_theme') || 'system';
  });

  const [tenantPrimaryColor, setTenantPrimaryColor] = useState(() => {
    return localStorage.getItem('tenant_primary_color') || '#2563eb';
  });

  useEffect(() => {
    const root = document.documentElement;
    
    // Apply dark/light class
    const applyTheme = (isDark) => {
      if (isDark) {
        root.classList.add('dark');
      } else {
        root.classList.remove('dark');
      }
    };

    if (theme === 'system') {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      applyTheme(mediaQuery.matches);

      const handler = (e) => applyTheme(e.matches);
      mediaQuery.addEventListener('change', handler);
      return () => mediaQuery.removeEventListener('change', handler);
    } else {
      applyTheme(theme === 'dark');
    }

    localStorage.setItem('saas_theme', theme);
  }, [theme]);

  // Apply tenant branding color
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty('--tenant-primary-color', tenantPrimaryColor);
    root.style.setProperty('--brand-600', tenantPrimaryColor);
    localStorage.setItem('tenant_primary_color', tenantPrimaryColor);
  }, [tenantPrimaryColor]);

  const updateTenantColor = (color) => {
    setTenantPrimaryColor(color);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, tenantPrimaryColor, updateTenantColor }}>
      {children}
    </ThemeContext.Provider>
  );
};
